/* JOYAR – globales Theme-JS (bewusst schlank, kein Framework) */
(function () {
  'use strict';

  /* ---------- Scroll-Reveal ---------- */
  function initReveal() {
    if (!document.body.classList.contains('reveal-enabled')) return;
    var els = document.querySelectorAll('.reveal:not(.is-visible)');
    if (!els.length || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Transparenter Header (Startseite) ---------- */
  function initTransparentHeader() {
    var header = document.querySelector('.site-header--transparent');
    if (!header) return;
    var announcement = document.querySelector('.announcement-bar');
    function place() {
      var offset = 0;
      if (announcement) {
        var rect = announcement.getBoundingClientRect();
        offset = Math.max(0, rect.bottom);
      }
      header.style.setProperty('--header-top', offset + 'px');
      header.classList.toggle('is-scrolled', window.scrollY > 24);
    }
    place();
    window.addEventListener('scroll', place, { passive: true });
    window.addEventListener('resize', place);
  }

  /* ---------- Mobile Navigation (native <dialog>) ---------- */
  function initMobileNav() {
    var dialog = document.getElementById('MobileNav');
    var openBtn = document.querySelector('[data-mobile-nav-open]');
    if (!dialog || !openBtn) return;
    openBtn.addEventListener('click', function () { dialog.showModal(); });
    dialog.addEventListener('click', function (e) {
      if (e.target === dialog || e.target.closest('[data-mobile-nav-close]') || e.target.closest('a')) {
        dialog.close();
      }
    });
    dialog.querySelectorAll('[data-submenu-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var group = btn.closest('.mobile-nav__group');
        if (!group) return;
        var open = group.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* ---------- Cart-Drawer (Schnellansicht) ---------- */
  function formatMoney(cents, currency) {
    try {
      return (cents / 100).toLocaleString(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: currency || 'EUR'
      });
    } catch (e) {
      return (cents / 100).toFixed(2) + ' ' + (currency || 'EUR');
    }
  }
  function updateCartBadges(count) {
    document.querySelectorAll('[data-cart-open]').forEach(function (link) {
      var badge = link.querySelector('.cart-count');
      if (count > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'cart-count';
          badge.setAttribute('aria-hidden', 'true');
          link.appendChild(badge);
        }
        badge.textContent = count;
      } else if (badge) {
        badge.remove();
      }
    });
  }
  function initCartDrawer() {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer) return;
    var body = drawer.querySelector('[data-drawer-body]');
    var subtotalEl = drawer.querySelector('[data-drawer-subtotal]');
    var foot = drawer.querySelector('[data-drawer-foot]');

    function render(cart) {
      updateCartBadges(cart.item_count);
      body.textContent = '';
      if (!cart.items.length) {
        var empty = document.createElement('p');
        empty.className = 'cart-drawer__empty';
        empty.textContent = drawer.dataset.textEmpty;
        body.appendChild(empty);
        if (foot) foot.hidden = true;
        return;
      }
      if (foot) foot.hidden = false;
      cart.items.forEach(function (item, index) {
        var row = document.createElement('div');
        row.className = 'drawer-line';

        var mediaLink = document.createElement('a');
        mediaLink.className = 'drawer-line__media';
        mediaLink.href = item.url;
        if (item.image) {
          var img = document.createElement('img');
          img.src = item.image.replace(/(\.[a-z]+)(\?|$)/, '_200x$1$2');
          img.alt = item.product_title;
          img.loading = 'lazy';
          mediaLink.appendChild(img);
        }

        var info = document.createElement('div');
        var titleLink = document.createElement('a');
        titleLink.className = 'drawer-line__title';
        titleLink.href = item.url;
        titleLink.textContent = item.product_title;
        info.appendChild(titleLink);
        if (item.variant_title) {
          var meta = document.createElement('p');
          meta.className = 'drawer-line__price';
          meta.textContent = item.variant_title;
          info.appendChild(meta);
        }
        var price = document.createElement('p');
        price.className = 'drawer-line__price';
        price.textContent = formatMoney(item.final_price, cart.currency);
        info.appendChild(price);

        var qty = document.createElement('div');
        qty.className = 'drawer-line__qty';
        var minus = document.createElement('button');
        minus.type = 'button';
        minus.textContent = '−';
        minus.setAttribute('aria-label', drawer.dataset.textQtyDown);
        minus.addEventListener('click', function () { change(index + 1, item.quantity - 1); });
        var count = document.createElement('span');
        count.textContent = item.quantity;
        var plus = document.createElement('button');
        plus.type = 'button';
        plus.textContent = '+';
        plus.setAttribute('aria-label', drawer.dataset.textQtyUp);
        plus.addEventListener('click', function () { change(index + 1, item.quantity + 1); });
        qty.appendChild(minus);
        qty.appendChild(count);
        qty.appendChild(plus);
        info.appendChild(qty);

        var right = document.createElement('div');
        var total = document.createElement('div');
        total.className = 'drawer-line__total';
        total.textContent = formatMoney(item.final_line_price, cart.currency);
        var remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'drawer-line__remove';
        remove.textContent = drawer.dataset.textRemove;
        remove.addEventListener('click', function () { change(index + 1, 0); });
        right.appendChild(total);
        right.appendChild(remove);

        row.appendChild(mediaLink);
        row.appendChild(info);
        row.appendChild(right);
        body.appendChild(row);
      });
      if (subtotalEl) subtotalEl.textContent = formatMoney(cart.items_subtotal_price, cart.currency);
    }

    function refresh() {
      return fetch('/cart.js')
        .then(function (res) { return res.json(); })
        .then(render)
        .catch(function () { /* offline o. Ä. – Drawer zeigt letzten Stand */ });
    }
    function change(line, quantity) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      })
        .then(function (res) { return res.json(); })
        .then(render)
        .catch(function () { refresh(); });
    }

    document.querySelectorAll('[data-cart-open]').forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        refresh().then(function () { drawer.showModal(); });
        drawer.showModal();
      });
    });
    drawer.addEventListener('click', function (e) {
      if (e.target === drawer || e.target.closest('[data-cart-close]')) drawer.close();
    });

    /* AJAX-Add-to-Cart: Produktformulare öffnen den Drawer statt zur Cart-Seite zu springen */
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('[data-buy-button]');
        if (btn) btn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          body: new FormData(form),
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        })
          .then(function (res) {
            if (!res.ok) throw new Error('add failed');
            return refresh();
          })
          .then(function () { drawer.showModal(); })
          .catch(function () { form.submit(); })
          .finally(function () { if (btn) btn.disabled = false; });
      });
    });
  }

  /* ---------- Horizontale Produkt-Slider ---------- */
  function initSliders(root) {
    (root || document).querySelectorAll('[data-slider]').forEach(function (slider) {
      if (slider.dataset.sliderInit) return;
      slider.dataset.sliderInit = '1';
      var track = slider.querySelector('[data-slider-track]');
      var prev = slider.querySelector('[data-slider-prev]');
      var next = slider.querySelector('[data-slider-next]');
      if (!track) return;

      var progressWrap = slider.querySelector('.pslider__progress');
      var progressBar = slider.querySelector('[data-slider-progress]');

      function step() {
        var item = track.querySelector(':scope > *');
        if (!item) return track.clientWidth * 0.8;
        var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
        return item.getBoundingClientRect().width + gap;
      }
      function update() {
        var maxScroll = track.scrollWidth - track.clientWidth;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= maxScroll - 2;
        if (progressWrap && progressBar) {
          if (maxScroll <= 4) {
            progressWrap.classList.add('is-hidden');
          } else {
            progressWrap.classList.remove('is-hidden');
            var thumbRatio = track.clientWidth / track.scrollWidth;
            var thumbWidth = Math.max(thumbRatio * 100, 12);
            var position = track.scrollLeft / maxScroll;
            var travel = 100 - thumbWidth;
            progressBar.style.width = thumbWidth + '%';
            progressBar.style.transform = 'translateX(' + (position * travel / thumbWidth * 100) + '%)';
          }
        }
      }
      window.addEventListener('resize', update);
      window.addEventListener('load', update);
      if (prev) prev.addEventListener('click', function () {
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      });
      if (next) next.addEventListener('click', function () {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      });
      track.addEventListener('scroll', update, { passive: true });
      update();
    });
  }

  /* ---------- Wunschliste (lokal, ohne App) ---------- */
  var WISHLIST_KEY = 'joyar:wishlist';
  function readWishlist() {
    try { return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || []; } catch (e) { return []; }
  }
  function initWishlist(root) {
    var list = readWishlist();
    (root || document).querySelectorAll('[data-wishlist]').forEach(function (btn) {
      if (btn.dataset.wishlistInit) return;
      btn.dataset.wishlistInit = '1';
      var handle = btn.dataset.wishlist;
      if (list.indexOf(handle) !== -1) btn.classList.add('is-active');
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var current = readWishlist();
        var idx = current.indexOf(handle);
        if (idx === -1) { current.push(handle); btn.classList.add('is-active'); }
        else { current.splice(idx, 1); btn.classList.remove('is-active'); }
        try { localStorage.setItem(WISHLIST_KEY, JSON.stringify(current)); } catch (err) { /* voll/blockiert – egal */ }
      });
    });
  }

  /* ---------- Produktgalerie: Carousel + Dots + Zoom ---------- */
  function initGallery() {
    document.querySelectorAll('[data-pgallery]').forEach(function (gallery) {
      var track = gallery.querySelector('[data-pgallery-track]');
      var slides = gallery.querySelectorAll('[data-pgallery-slide]');
      var dots = gallery.querySelectorAll('[data-pgallery-dot]');
      var prev = gallery.querySelector('[data-pgallery-prev]');
      var next = gallery.querySelector('[data-pgallery-next]');
      var zoomDialog = gallery.querySelector('[data-zoom-dialog]');
      var zoomImg = zoomDialog ? zoomDialog.querySelector('img') : null;
      if (!track || !slides.length) return;

      function currentIndex() {
        return Math.round(track.scrollLeft / track.clientWidth);
      }
      function goTo(i) {
        i = Math.max(0, Math.min(slides.length - 1, i));
        track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
      }
      function updateDots() {
        var i = currentIndex();
        dots.forEach(function (d, di) { d.classList.toggle('is-active', di === i); });
      }
      track.addEventListener('scroll', function () {
        window.requestAnimationFrame(updateDots);
      }, { passive: true });
      dots.forEach(function (dot, di) {
        dot.addEventListener('click', function () { goTo(di); });
      });
      if (prev) prev.addEventListener('click', function () { goTo(currentIndex() - 1); });
      if (next) next.addEventListener('click', function () { goTo(currentIndex() + 1); });

      if (zoomDialog && zoomImg) {
        slides.forEach(function (slide) {
          slide.addEventListener('click', function () {
            var img = slide.querySelector('img');
            if (!img) return;
            zoomImg.src = img.dataset.zoom || img.src;
            zoomImg.alt = img.alt;
            zoomDialog.showModal();
          });
        });
        zoomDialog.addEventListener('click', function (e) {
          if (e.target === zoomDialog || e.target.closest('[data-zoom-close]')) zoomDialog.close();
        });
      }
      updateDots();
    });
  }

  /* ---------- Mengen-Stepper ---------- */
  function initQty() {
    document.querySelectorAll('[data-qty]').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      wrap.addEventListener('click', function (e) {
        var btn = e.target.closest('button');
        if (!btn || !input) return;
        var val = parseInt(input.value, 10) || 1;
        if (btn.dataset.step === 'up') input.value = val + 1;
        else input.value = Math.max(1, val - 1);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  /* ---------- Variantenwahl auf der Produktseite ---------- */
  function initVariantPicker() {
    document.querySelectorAll('[data-product-form]').forEach(function (root) {
      var select = root.querySelector('[data-variant-select]');
      var idInput = root.querySelector('input[name="id"]');
      var priceEl = root.querySelector('[data-price]');
      var buyBtn = root.querySelector('[data-buy-button]');
      var jsonEl = root.querySelector('[data-product-json]');
      if (!select || !idInput || !jsonEl) return;
      var product;
      try { product = JSON.parse(jsonEl.textContent); } catch (e) { return; }

      select.addEventListener('change', function () {
        var variant = product.variants.find(function (v) {
          return String(v.id) === select.value;
        });
        if (!variant) return;
        idInput.value = variant.id;
        if (priceEl) {
          priceEl.textContent = (variant.price / 100).toLocaleString(
            document.documentElement.lang || 'de',
            { style: 'currency', currency: product.currency || 'EUR' }
          );
        }
        if (buyBtn) {
          buyBtn.disabled = !variant.available;
          var label = buyBtn.querySelector('[data-buy-label]');
          if (label) {
            label.textContent = variant.available
              ? buyBtn.dataset.textAdd
              : buyBtn.dataset.textSoldOut;
          }
        }
      });
    });
  }

  /* ---------- Filter-Dropdowns ---------- */
  function initFilterGroups() {
    var groups = document.querySelectorAll('details.filter-group');
    if (!groups.length) return;
    groups.forEach(function (group) {
      group.addEventListener('toggle', function () {
        if (!group.open) return;
        groups.forEach(function (other) {
          if (other !== group) other.open = false;
        });
      });
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest('details.filter-group')) {
        groups.forEach(function (g) { g.open = false; });
      }
    });
  }

  /* ---------- Footer-Accordions: auf Desktop offen ---------- */
  function initFooterAccordions() {
    function apply() {
      var open = window.matchMedia('(min-width: 750px)').matches;
      document.querySelectorAll('details.footer-acc').forEach(function (d) {
        d.open = open ? true : d.open;
        if (open) d.open = true;
      });
    }
    apply();
    window.matchMedia('(min-width: 750px)').addEventListener('change', apply);
  }

  /* ---------- Cross-Sell: Shopify Product Recommendations ---------- */
  function initRecommendations() {
    document.querySelectorAll('[data-recommendations]').forEach(function (holder) {
      var url = holder.dataset.url;
      if (!url) return;
      fetch(url)
        .then(function (res) { return res.text(); })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var inner = doc.querySelector('[data-recommendations]');
          if (inner && inner.innerHTML.trim()) {
            holder.innerHTML = inner.innerHTML;
            initReveal();
            initSliders(holder);
            initWishlist(holder);
          } else {
            var section = holder.closest('.shopify-section');
            if (section) section.style.display = 'none';
          }
        })
        .catch(function () { /* Empfehlungen sind optional */ });
    });
  }

  /* ---------- Zuletzt angesehen (localStorage) ---------- */
  var RECENT_KEY = 'joyar:recent';
  function trackRecentProduct() {
    var el = document.querySelector('[data-recent-product]');
    if (!el) return;
    var entry;
    try { entry = JSON.parse(el.textContent); } catch (e) { return; }
    if (!entry || !entry.handle) return;
    var list;
    try { list = JSON.parse(localStorage.getItem(RECENT_KEY)) || []; } catch (e) { list = []; }
    list = list.filter(function (p) { return p.handle !== entry.handle; });
    list.unshift(entry);
    list = list.slice(0, 10);
    try { localStorage.setItem(RECENT_KEY, JSON.stringify(list)); } catch (e) { /* egal */ }
  }
  function renderRecentlyViewed() {
    var holder = document.querySelector('[data-recent-list]');
    if (!holder) return;
    var exclude = holder.dataset.exclude || '';
    var list;
    try { list = JSON.parse(localStorage.getItem(RECENT_KEY)) || []; } catch (e) { list = []; }
    list = list.filter(function (p) { return p.handle !== exclude; }).slice(0, 8);
    if (!list.length) {
      var section = holder.closest('.shopify-section');
      if (section) section.style.display = 'none';
      return;
    }
    var frag = document.createDocumentFragment();
    list.forEach(function (p) {
      var item = document.createElement('div');
      item.className = 'pslider__item';
      var article = document.createElement('article');
      article.className = 'product-card';
      var media = document.createElement('div');
      media.className = 'product-card__media';
      if (p.image) {
        var img = document.createElement('img');
        img.src = p.image;
        img.alt = p.title || '';
        img.loading = 'lazy';
        media.appendChild(img);
      }
      var info = document.createElement('div');
      info.className = 'product-card__info';
      var h = document.createElement('h3');
      h.className = 'product-card__title';
      var a = document.createElement('a');
      a.href = p.url || '#';
      a.textContent = p.title || '';
      h.appendChild(a);
      var price = document.createElement('div');
      price.className = 'product-card__price';
      price.textContent = p.price || '';
      info.appendChild(h);
      info.appendChild(price);
      article.appendChild(media);
      article.appendChild(info);
      item.appendChild(article);
      frag.appendChild(item);
    });
    holder.appendChild(frag);
    initSliders(holder.closest('[data-slider]') ? holder.closest('.shopify-section') : document);
  }

  /* ---------- Such-Overlay mit Live-Vorschlägen ---------- */
  function initSearchModal() {
    var modal = document.getElementById('SearchModal');
    if (!modal) return;
    var input = modal.querySelector('[data-search-input]');
    var results = modal.querySelector('[data-search-results]');
    var currency = modal.dataset.currency || 'EUR';
    var debounceTimer = null;
    var lastQuery = '';

    document.querySelectorAll('[data-search-open]').forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        modal.showModal();
        setTimeout(function () { input.focus(); }, 50);
      });
    });
    modal.addEventListener('click', function (e) {
      if (e.target === modal || e.target.closest('[data-search-close]')) modal.close();
    });

    function renderResults(query, products) {
      results.textContent = '';
      if (!products.length) {
        var none = document.createElement('p');
        none.className = 'search-modal__empty';
        none.textContent = modal.dataset.textNoResults;
        results.appendChild(none);
        return;
      }
      var list = document.createElement('div');
      list.className = 'search-modal__grid';
      products.forEach(function (p) {
        var a = document.createElement('a');
        a.className = 'search-hit';
        a.href = p.url;
        if (p.featured_image && p.featured_image.url) {
          var img = document.createElement('img');
          img.src = p.featured_image.url.replace(/(\.[a-z]+)(\?|$)/, '_400x$1$2');
          img.alt = p.featured_image.alt || p.title;
          img.loading = 'lazy';
          a.appendChild(img);
        }
        var t = document.createElement('span');
        t.className = 'search-hit__title';
        t.textContent = p.title;
        a.appendChild(t);
        var pr = document.createElement('span');
        pr.className = 'search-hit__price';
        var priceNum = parseFloat(p.price);
        if (!isNaN(priceNum)) {
          try {
            pr.textContent = priceNum.toLocaleString(document.documentElement.lang || 'en', { style: 'currency', currency: currency });
          } catch (err) {
            pr.textContent = p.price + ' ' + currency;
          }
        }
        a.appendChild(pr);
        list.appendChild(a);
      });
      results.appendChild(list);

      var all = document.createElement('a');
      all.className = 'search-modal__all link-arrow';
      all.href = '/search?q=' + encodeURIComponent(query);
      all.textContent = modal.dataset.textViewAll + ' „' + query + '"';
      results.appendChild(all);
    }

    input.addEventListener('input', function () {
      var query = input.value.trim();
      clearTimeout(debounceTimer);
      if (query.length < 2) {
        results.textContent = '';
        lastQuery = '';
        return;
      }
      debounceTimer = setTimeout(function () {
        lastQuery = query;
        fetch(
          '/search/suggest.json?q=' + encodeURIComponent(query) +
          '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last'
        )
          .then(function (res) { return res.json(); })
          .then(function (data) {
            if (query !== lastQuery) return;
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            renderResults(query, products);
          })
          .catch(function () { /* Vorschläge sind optional */ });
      }, 250);
    });
  }

  /* ---------- Weiche Auf-/Zuklapp-Animation für Accordions ---------- */
  function initAnimatedDetails() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.querySelectorAll('details.accordion__item, details.footer-acc').forEach(function (detail) {
      var summary = detail.querySelector(':scope > summary');
      var panel = detail.querySelector(':scope > *:not(summary)');
      if (!summary || !panel || !panel.animate) return;
      var animating = false;
      summary.addEventListener('click', function (e) {
        if (getComputedStyle(summary).pointerEvents === 'none') return;
        e.preventDefault();
        if (animating) return;
        animating = true;
        var settle = function (callback) {
          var done = false;
          return function () {
            if (done) return;
            done = true;
            panel.style.overflow = '';
            animating = false;
            callback();
          };
        };
        if (detail.open) {
          var height = panel.offsetHeight;
          panel.style.overflow = 'hidden';
          var closeAnim = panel.animate(
            { height: [height + 'px', '0px'], opacity: [1, 0] },
            // fill: 'forwards' hält die Endhöhe fest. Ohne das springt
            // das Panel nach der Animation für einen Frame auf seine
            // natürliche Höhe zurück, bevor open = false greift – das
            // ist das kurze Stocken und Zurückschnappen beim Schließen.
            { duration: 260, easing: 'ease', fill: 'forwards' }
          );
          var closeDone = settle(function () {
            detail.open = false;
            // Erst jetzt darf der festgehaltene Endzustand weg, sonst
            // blitzt das offene Panel noch einmal auf.
            closeAnim.cancel();
          });
          closeAnim.onfinish = closeDone;
          setTimeout(closeDone, 400);
        } else {
          detail.open = true;
          var target = panel.offsetHeight;
          panel.style.overflow = 'hidden';
          var openDone = settle(function () {});
          var openAnim = panel.animate(
            {
              height: ['0px', target + 'px'],
              opacity: [0, 1],
              transform: ['translateY(-6px)', 'none']
            },
            { duration: 340, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' }
          );
          openAnim.onfinish = openDone;
          openAnim.oncancel = openDone;
          setTimeout(openDone, 480);
        }
      });
    });
  }

  /* ---------- Produktbeschreibung normalisieren ---------- */
  function initProductDescription() {
    var root = document.querySelector('.product-description');
    if (!root) return;

    // Aus dem Admin kommen Inline-Styles (font-weight, font-size) mit,
    // die je Produkt anders sind. Weg damit.
    Array.prototype.forEach.call(root.querySelectorAll('[style]'), function (el) {
      el.removeAttribute('style');
    });

    Array.prototype.forEach.call(root.querySelectorAll('p'), function (p) {
      var text = p.textContent.replace(/\s+/g, ' ').trim();
      if (!text) { p.remove(); return; }

      // "Label: Wert" nur trennen, wenn der Doppelpunkt früh steht und
      // danach noch etwas kommt – sonst bleibt der Absatz, wie er ist.
      var split = text.indexOf(':');
      if (split < 1 || split > 40 || split === text.length - 1) {
        p.textContent = text;
        return;
      }

      var label = document.createElement('span');
      label.className = 'product-description__label';
      label.textContent = text.slice(0, split).trim();

      var value = document.createElement('span');
      value.className = 'product-description__value';
      value.textContent = text.slice(split + 1).trim();

      p.textContent = '';
      p.appendChild(label);
      p.appendChild(value);
    });
  }

  /* ---------- Hero-Slideshow ---------- */
  function initHeroSlideshow() {
    var root = document.querySelector('[data-hslide]');
    if (!root) return;

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-hslide-slide]'));
    if (slides.length === 0) return;

    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-hslide-dot]'));
    var interval = parseInt(root.getAttribute('data-interval'), 10) || 6000;
    var wantsAutoplay = root.getAttribute('data-autoplay') === 'true' && slides.length > 1;
    var calm = window.matchMedia('(prefers-reduced-motion: reduce)');
    var index = 0;
    var timer = null;

    function playVisibleVideo(slide) {
      var videos = slide.querySelectorAll('[data-hslide-video]');
      Array.prototype.forEach.call(videos, function (video) {
        // offsetParent ist null, solange der Breakpoint-Wrapper
        // ausgeblendet ist – so lädt nur das sichtbare Video.
        if (video.offsetParent === null) return;
        if (!video.getAttribute('data-mounted')) {
          video.setAttribute('data-mounted', '1');
          video.load();
        }
        var attempt = video.play();
        if (attempt && attempt.catch) attempt.catch(function () {});
      });
    }

    function stopVideos(slide) {
      var videos = slide.querySelectorAll('[data-hslide-video]');
      Array.prototype.forEach.call(videos, function (video) { video.pause(); });
    }

    function show(next) {
      if (next === index) return;
      var previous = slides[index];
      previous.classList.remove('is-active');
      previous.setAttribute('aria-hidden', 'true');
      previous.setAttribute('inert', '');
      stopVideos(previous);

      index = (next + slides.length) % slides.length;
      var current = slides[index];
      current.classList.add('is-active');
      current.removeAttribute('aria-hidden');
      current.removeAttribute('inert');
      playVisibleVideo(current);

      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
        // Bereits gezeigte Segmente bleiben gefüllt stehen.
        dot.classList.toggle('is-done', i < index);
        if (i === index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });

      restartProgress();
    }

    // Startet die CSS-Animation des aktiven Segments neu. Ein Reflow auf
    // dem Element selbst ist der zuverlässige Weg dafür.
    function restartProgress() {
      var dot = dots[index];
      if (!dot) return;
      var fill = dot.querySelector('.hslide__seg-fill');
      if (!fill) return;
      fill.style.animation = 'none';
      void fill.offsetWidth;
      fill.style.animation = '';
    }

    function start() {
      if (!wantsAutoplay || calm.matches || timer) return;
      root.removeAttribute('data-paused');
      // Timer und Balken starten gemeinsam bei null, damit die Anzeige
      // nicht gegenüber dem tatsächlichen Wechsel verrutscht.
      restartProgress();
      timer = window.setInterval(function () { show(index + 1); }, interval);
    }

    function stop() {
      if (!timer) return;
      window.clearInterval(timer);
      timer = null;
      root.setAttribute('data-paused', '');
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        stop();
        show(i);
        start();
      });
    });

    function wireNav(selector, step) {
      var button = root.querySelector(selector);
      if (!button) return;
      button.addEventListener('click', function () {
        stop();
        show(index + step);
        start();
      });
    }
    wireNav('[data-hslide-prev]', -1);
    wireNav('[data-hslide-next]', 1);

    if (wantsAutoplay && !calm.matches) root.setAttribute('data-autoplaying', '');

    // Pausieren, solange jemand hovert, per Tastatur drin ist oder
    // der Tab im Hintergrund liegt.
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop(); else start();
    });

    // Wischen
    var touchStartX = null;
    root.addEventListener('touchstart', function (event) {
      touchStartX = event.changedTouches[0].clientX;
      stop();
    }, { passive: true });
    root.addEventListener('touchend', function (event) {
      if (touchStartX === null) return;
      var delta = event.changedTouches[0].clientX - touchStartX;
      if (Math.abs(delta) > 45) show(index + (delta < 0 ? 1 : -1));
      touchStartX = null;
      start();
    }, { passive: true });

    // Pfeiltasten, sobald die Punkte den Fokus haben
    root.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowRight') { stop(); show(index + 1); start(); }
      if (event.key === 'ArrowLeft') { stop(); show(index - 1); start(); }
    });

    // Breakpointwechsel: das jetzt sichtbare Video übernimmt
    window.matchMedia('(min-width: 750px)').addEventListener('change', function () {
      stopVideos(slides[index]);
      playVisibleVideo(slides[index]);
    });

    // Die Bilder der verborgenen Slides liegen als lazy im Markup, damit
    // sie nicht mit dem ersten Bild um Bandbreite konkurrieren. Sobald
    // die Seite steht, werden sie vorgeladen – sonst erscheint beim
    // ersten Wechsel für einen Moment eine leere Fläche.
    function preloadRemainingSlides() {
      slides.forEach(function (slide, i) {
        if (i === 0) return;
        var img = slide.querySelector('img[loading="lazy"]');
        if (img) img.loading = 'eager';
      });
    }
    if (document.readyState === 'complete') preloadRemainingSlides();
    else window.addEventListener('load', preloadRemainingSlides);

    playVisibleVideo(slides[0]);
    start();
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initHeroSlideshow();
    initProductDescription();
    initTransparentHeader();
    initMobileNav();
    initCartDrawer();
    initSearchModal();
    initAnimatedDetails();
    initSliders();
    initWishlist();
    initGallery();
    initQty();
    initVariantPicker();
    initFilterGroups();
    initFooterAccordions();
    initRecommendations();
    trackRecentProduct();
    renderRecentlyViewed();
  });
})();
